<template>
  <div class="cargo-info">
    <div class="cargo-info-text">
      <h2 class="vz-text-align-left">В компании Возовоз качество транспортировки груза на первом месте</h2>
      <p>Грузоперевозки – это неотъемлемая часть современной логистики. Будь то доставка товаров, перевозка 
      мебели или других грузов, важно обратиться к профессионалам, которые смогут обеспечить надежную и 
      безопасную доставку.</p>

      <h3>Мы занимаемся грузоперевозками уже {{ yearCount }} лет и за это время завоевала доверие многих клиентов</h3>
      <p>Возовоз предлагает перевозку специальным транспортом, который перевезет груз любого объема и вида. 
      Благодаря команде профессиональных водителей и грузчиков, грузоперевозки становятся максимально 
      быстрыми и безопасными.</p>

      <h3>Мы перевозим грузы <nuxt-link :to="({ name: 'terminals' })" target="_blank">по России</nuxt-link> 
      и за ее пределы </h3>
      <p>Клиентам доступны как срочная экспресс-доставка груза, так и плановые маршруты.</p>

      <h3>Клиенты заранее узнают стоимость перевозки и могут точно рассчитать бюджет.</h3>
      <p>Одно из преимуществ работы с компанией Возовоз – это прозрачная система ценообразования. Нужно ли
      перевезти небольшой груз или организовать полноценную логистическую цепочку, мы всегда предлагаем 
      индивидуальный подход и оптимальные <nuxt-link :to="({ name: 'tariffs' })" target="_blank">тарифы</nuxt-link>.
      Это позволяет планировать затраты и избежать неприятных сюрпризов.</p>

      <h3>Обеспечиваем надежную упаковку груза и контроль над его состоянием на всем пути следования</h3>
      <p>Это гарантирует сохранность товара и помогает избежать потерь или повреждений.</p>

      <h3>Грузоперевозки в компании Возовоз – это надежность, качество и оптимальные цены.</h3>
      <p>Если вам необходимо перевезти груз, не стоит обращаться к случайным перевозчикам. Доверьте эту 
      задачу профессионалам и убедитесь в качестве услуг от компании Возовоз!</p>
    </div>
    <img src="/images/pages/shipping/truck.png" alt="">
  </div>
</template>

<script setup lang="ts">
const yearCount = new Date().getFullYear() - 2014
</script>

<style scoped lang="scss">
.cargo-info {
  display: flex;
  align-items: flex-start;
  gap: 40px;

  p {
    margin-bottom: 30px;
    text-align: justify;
  }

  :deep(h3) {
    margin-bottom: 10px;
  }

  img {
    object-fit: contain;
    max-width: 100%;
  }

  @media screen and (max-width: $pub-md) {
    img {
      width: 336px;
    }
  }

  @media screen and (max-width: $pub-xs) {
    flex-wrap: wrap;
    justify-content: center;

    img {
      width: unset;
    }
  }
}
</style>
